export default __webpack_public_path__ + "static/perfective-imperative-1ba0a8d5bb1d4e9555e7fc2ddf78e701.svg";